import { createTransform, persistStore, storages } from 'redux-persist'
import _ from 'lodash'
import filterOpenTokPublisher from './filter-opentok-publisher'

const setupPersist = (store) => {
  // Create the redux-persist transform. Enable only for the "global" reducer.
  const publisherFilterTransform = createTransform(filterOpenTokPublisher, _.identity, { whitelist: ['global'] })

  persistStore(
    store,
    {
      blacklist: ['routing'],
      storage: storages.asyncSessionStorage,
      transforms: [publisherFilterTransform],
    }
  )
}

export default setupPersist
